import React, { PureComponent } from 'react'
import Layout from '../components/layout'
import Credits from '../components/sfc/credits'
import NavTop from '../components/sfc/navtop'
import WCMImage from '../components/sfc/wcmimage'
import RssFeed from '../components/rssfeed'
import RestaurantCard from '../components/restaurantcard'
import GuidesRow from '../components/sfc/guidesrow'
import TrackerMap from '../components/trackermap'

// importing Guides styles
import "../styles/guides.less";
// Get data from config
let projectConfig = require("../../project-config.json");

// bring in restaurant data
const guidesData = require('../data/guides.sheet.json');
const restaurantsData = require('../data/restaurants.sheet.json');

// Run some logic to find out how many restaurants are in each guide
var restObj = {};
// Create a prop for each guide
for (let guide in guidesData){
  restObj[guidesData[guide].Guide] = 0;
}
// Now count how many restaurants
for (let restaurant in restaurantsData){
  if (restaurantsData[restaurant].Guide){
    let guideArray = restaurantsData[restaurant].Guide.split(",");
    // Now that we have the guides, increment each
    for (let item in guideArray){
      let guideTitle = guideArray[item].trim();
      if (typeof restObj[guideTitle] != "undefined"){
        // Add one to this guide
        restObj[guideTitle] += 1;
      }
    }
  }
}

export default class Guide extends PureComponent {

  constructor(props){
    super(props);

    // Set state
    this.state = {
      more_intro: false,
      more_item_text: false
    }

    // Prep ref for scrolling
    this.listSection = React.createRef();
  }

  componentDidMount(){
    let savedList = this.getUrlParam("list", "");
    if (savedList && savedList.length === 34){
      this.decodeURL(savedList);
    }
  }

	prepDates () {
    // Convert date to readable time
    this.readablePubDate = this.convertDatesToAP(projectConfig.PROJECT.DATE);
    // Check safely for MOD_DATE
    if (typeof projectConfig.PROJECT.MOD_DATE !== "undefined"){
      this.readableModDate = this.convertDatesToAP(projectConfig.PROJECT.MOD_DATE);
    } else {
      // If MOD_DATE does not exist, set false so it doesn't render
      this.readableModDate = false;
    }
  }

  convertDatesToAP (dateString) {
  	// Convert date string to AP style abbreviations
  	let newDateString = dateString;
  	newDateString = newDateString.replace('January', 'Jan.').replace('February', 'Feb.').replace('August', 'Aug.').replace('September', 'Sept.').replace('October', 'Oct.').replace('November','Nov.').replace('December','Dec.');
  	// Return the result
  	return newDateString;
  }

  adjustList(e, number) {
    e.preventDefault();
    e.stopPropagation();
    // Toggle state to reflect the click
    this.setState({
      [number+1]: !this.state[number+1]
    }, () => {
      // This should work in modern browsers
      if (window.history){
        window.history.replaceState('', '', '?list='+this.encodeURL());
      }
    });
  }

  getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
    });
    return vars;
  }

  getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
      urlparameter = this.getUrlVars()[parameter];
    }
    return urlparameter;
  }

  encodeURL(){
    // Forgive me for this insane idea, but this is how we can reduce the query string length but keep tabs on the data
    let encodedString = "";
    let encodedVals = false;
    for (let i = 1; i <= 100; i+=3){
      // Add the numbers together to get encoded var
      let addedNum = 0;
      if (this.state[i] === true){
        addedNum += 1;
        encodedVals = true;
      }
      if (this.state[i+1] === true){
        addedNum += 2;
        encodedVals = true;
      }
      if (this.state[i+2] === true){
        addedNum += 5;
        encodedVals = true;
      }
      // Add encoded num to the string
      encodedString += addedNum;
    }
    if (encodedVals){
      return encodedString;
    } else {
      // If there were no selected restaurants, return an empty string
      return "";
    }

  }

  decodeURL(savedList){
    // Forgive me for this insane idea, but this is how we can reduce the query string length but keep tabs on the data
    // Create a false state object we can modify
    let stateObj = {};
    for (let i = 1; i <= 100; i++){
      stateObj[i] = false;
    }
    // This is the exact number is needs to be to get decoded into state, do so
    for (let i = 0; i < savedList.length - 1; i++){
      let im = i*3;
      // One true
      if (savedList[i] === "1"){
        stateObj[im+1] = true;
      }
      if (savedList[i] === "2"){
        stateObj[im+2] = true;
      }
      if (savedList[i] === "5"){
        stateObj[im+3] = true;
      }
      // Two true
      if (savedList[i] === "3"){
        stateObj[im+1] = true;
        stateObj[im+2] = true;
      }
      if (savedList[i] === "6"){
        stateObj[im+1] = true;
        stateObj[im+3] = true;
      }
      if (savedList[i] === "7"){
        stateObj[im+2] = true;
        stateObj[im+3] = true;
      }
      // Three true
      if (savedList[i] === "8"){
        stateObj[im+1] = true;
        stateObj[im+2] = true;
        stateObj[im+3] = true;
      }
    }

    // Catch the last one that completes the 100
    if (savedList[33] === "1"){
      stateObj[100] = true;
    }

    // Set the state with the new vars
    this.setState({
      ...stateObj
    });
  }

	render () {
    const context = this.props.pageContext.page;

    // keep track of restaurants in the guide
    let guideRestaurants = [];

  	// Handle date parsing
  	this.prepDates();

  	// Convert date string to AP style abbreviations
  	let pubdateString = this.readablePubDate;
  	let moddateString = "";
  	// Only check moddate if we have a value
  	if (this.readableModDate){
  		moddateString = this.readableModDate;

  		// Chop time off pubdate if possible
  		try {
      	this.readablePubDate = this.readablePubDate.match(/.*\d{4}/gm)[0];
      } catch (err){
      	// That's fine
      	console.log(err);
      }
  	}

    let encodedVal = this.encodeURL();
    if (encodedVal){
      encodedVal = "?list=" + encodedVal;
    }

    const guideSlug = context.Guide.toLowerCase().trim().replace(/\s/g, '-').replace(/[']/g, '')

		return (

		  <Layout
        title={context.SEO_Title}
        social_title={context.SEO_Title}
        description={context.SEO_Description}
        url_add={guideSlug}
        image={"https://s.hdnux.com/photos/0/0/0/0/"+context.Social_ImageID+"/0/1200x0.jpg"}
        url_add={context.Guide.toLowerCase().trim().replace(/\s/g, '-').replace(/['\&]/g, '')}
      >

		    <div id="project-wrapper">

          {/* This prop will allow the nav to stick when user scrolls past */}
          <NavTop linkExt={encodedVal} />

          <div id="intro" className="guide-topper">
            <div className="topper">
              <div className="img-wrapper">
                <WCMImage WCMID={context.Topper_Art} />
              </div>
            </div>
            <div id="title">
              <div className="kicker"><span>Guide</span></div>
              <h1>{context.Headline}</h1>
              <p>{context.Overview_Text}</p>
            </div>
          </div>

          <div className="full-list-wrapper guide-page">

            <div className="full-list">

            {restaurantsData.map((restaurant, index) => {

                let guidesArray = [];

                if (restaurant.Guide){
                  guidesArray = restaurant.Guide.split(",");
                }

                const restaurantGuide = guidesArray.filter(guide => {
                  return guide === context.Guide;
                });


                if(restaurantGuide == context.Guide){
                  guideRestaurants.push(restaurant);
                  return (
                    <RestaurantCard key={"card"+index} restaurant={restaurant} index={index} linkExt={encodedVal} adjustList={this.adjustList.bind(this)} show={this.state[index+1]} />
                  )
                }
              })}

            </div>
          </div>

          <TrackerMap mapData={guideRestaurants} pageState={this.state} adjustList={this.adjustList.bind(this)} lat={context.Lat ? context.Lat : undefined} lng={context.Lng ? context.Lng : undefined} zoom={context.Zoom ? context.Zoom : undefined} linkExt={encodedVal} />

          <GuidesRow guide={context} restObj={restObj} linkExt={encodedVal} />

          <RssFeed title="More Chronicle reviews" />

          <Credits />

		    </div>
		  </Layout>
		)
	}
}
